import { createSlice } from '@reduxjs/toolkit'
import compareParts from '../../utils/constants/compareParts'
import _ from 'lodash'

let initialState = compareParts

export const comparePartsSlice = createSlice({
    name: 'compareParts',
    initialState,
    reducers: {
        setParts: (state, action) => action.payload,
        addPart: (state, action) => {
            state.push({
                hash: action.payload.hash,
                part_id: action.payload.part_id,
                article: action.payload.article,
                brand: action.payload.brand
            })
        },
        removePart: (state, action) => {
            state = _.remove(state, function (item) {
                return item.hash === action.payload.hash
            })
        }
    }
})

export const { setParts, addPart, removePart } = comparePartsSlice.actions

export const selectCompareParts = (state) => state.compareParts

export default comparePartsSlice.reducer
